import { render, staticRenderFns } from "./RegistryInfoCard.vue?vue&type=template&id=700b2b8e&scoped=true&"
import script from "./RegistryInfoCard.vue?vue&type=script&lang=js&"
export * from "./RegistryInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./RegistryInfoCard.vue?vue&type=style&index=0&id=700b2b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b2b8e",
  null
  
)

export default component.exports